import { render, staticRenderFns } from "./WorkExtraTypeTable.vue?vue&type=template&id=3c12d83b&"
import script from "./WorkExtraTypeTable.vue?vue&type=script&lang=js&"
export * from "./WorkExtraTypeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports